import React from 'react';
import './MobileStatItem.scss';
import classNames from 'classnames';

type Props = {
  value: number;
  label: string;
  blocker?: boolean;
  onClick?: () => void;
};

function MobileStatItem({ value, label, blocker, onClick }: Props): JSX.Element {
  return (
    <div className={classNames('MobileStatItem', { blocker, clickable: !!onClick })} onClick={onClick}>
      <div className="MobileStatItem-value">{value}</div>
      <div className="MobileStatItem-label">{label}</div>
    </div>
  );
}

export default MobileStatItem;
